import React from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Controla tus gastos sin Excel</h1>
        <p className="subtitle">Tu dinero, tus reglas, tu futuro. <br /> Adiós a las tablas infinitas.</p>
        <p className="hero-description">Libérate del Excel. Gestiona tus gastos, ahorros e inversiones de forma visual, automática y con planes de IA para tus metas.</p>
        <a href='https://app.findbalance.es' className="btn" data-event="hero_cta">Empieza gratis</a>
        <div className="hero-security-badges">
          <div className="hero-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2L3 7V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <span>Datos 100% cifrados</span>
          </div>
          <div className="hero-badge">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" />
              <path d="M9 9L15 15M15 9L9 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <span>Sin conexión bancaria</span>
          </div>
        </div>
      </div>
      <div className="hero-image">
        <div className="phone-mockup">
          <div className="phone-speaker"></div>
          <div className="phone-camera"></div>
          <div className="phone-side-buttons">
            <div className="phone-silent"></div>
            <div className="phone-volume-up"></div>
            <div className="phone-volume-down"></div>
            <div className="phone-power"></div>
          </div>
          <img src="home.png" className='' alt="Find Balance App Dashboard - Gestión de finanzas personales" />
          <div className="phone-home-indicator"></div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
